import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect, useState } from 'react';
import {
  $getSelection,
  $isRangeSelection,
  $createTextNode,
} from 'lexical';
import { createPortal } from 'react-dom';
import { List } from 'antd';
import { MentionNode} from './CustomNode';

export default function MentionPlugin({ users }) {
  const [editor] = useLexicalComposerContext();

  const [query, setQuery] = useState('');
  const [show, setShow] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        const selection = $getSelection();

        if (!$isRangeSelection(selection)) return;

        const text = selection.anchor.getNode().getTextContent();

        const match = text.match(/@(\w*)$/);

        if (match) {
          setQuery(match[1]);
          setShow(true);

          const domSelection = window.getSelection();
          if (domSelection.rangeCount > 0) {
            const rect = domSelection.getRangeAt(0).getBoundingClientRect();
            setPosition({
              top: rect.bottom + window.scrollY,
              left: rect.left + window.scrollX,
            });
          }
        } else {
          setShow(false);
        }
      });
    });
  }, [editor]);


  const filteredUsers = users.filter((u) =>
    u.username?.toLowerCase().includes(query.toLowerCase()),
  );

 const insertMention = (user) => {
  editor.update(() => {
    const selection = $getSelection();
    if (!$isRangeSelection(selection)) return;

    const node = selection.anchor.getNode();
    const offset = selection.anchor.offset;

    selection.setTextNodeRange(
      node,
      offset - (query.length + 1),
      node,
      offset
    );

    selection.insertText('');

    const mentionNode = new MentionNode(user.username);

    selection.insertNodes([
      mentionNode,
      $createTextNode(' '),
    ]);
  });

  setShow(false);
};

  if (!show) return null;

  return createPortal(
    <div
      style={{
        position: 'absolute',
        top: position.top,
        left: position.left,
        background: '#fff',
        border: '1px solid #ddd',
        borderRadius: 6,
        width: 220,
        zIndex: 1000,
      }}
    >
      <List
        size="small"
        dataSource={filteredUsers}
        renderItem={(user) => (
          <List.Item
            style={{ cursor: 'pointer' }}
            onClick={() => insertMention(user)}
          >
            {user.username}
          </List.Item>
        )}
      />
    </div>,
    document.body,
  );
}